import React, { useState } from "react";
import Active from "../../confirmation_Screen/Active";
import Delete from "../../confirmation_Screen/Delete";
import DraftMcqType from "../DraftQuestionList/DraftMcqType";
import "./deactivateQlist.css";
// import "./publishedQList.css";

const DeativateQList = () => {
  const [click, setClick] = useState(false);
  const [click1, setClick1] = useState(false);

  return (
    <>
      <div className="my-2 draft_q_filePath">
        <img src="images/Back Arrow.svg" className=" dq_back_arrow" alt="" />
        <span className="dq_first_path">Assessment</span>
        <span className="dq_back_slice">/</span>
        <span className="dq_second_path">English Assessment</span>
      </div>
      <div className="col-12 Drafted_question_header my-2">
        English Assessment
      </div>
      <div className="show_Drafted_container">
        <div className="sub_Drafted_status_container_Draft">
          <div className="Drafted_suject">social science</div>
          <div className="Drafted_box">Deactivated</div>
        </div>
        <div className="total_question_marks_btn_draft">
          <div className="total_question_marks_container">
            <div className="question-management">
              Total Questions:
              <div className="qno_management">01</div>
            </div>
            <div className="marks-management">
              total marks:
              <div className="qno_management">100</div>
            </div>
          </div>
          <div className="deactive_delete_btn" onClick={(e) => setClick1(true)}>
            Delete
          </div>
          <div className="deactived_btn" onClick={(e) => setClick(true)}>
            Active
          </div>
        </div>
      </div>

      <DraftMcqType />
      {click && <Active onChange={setClick} />}
      {click1 && <Delete onChange={setClick1} />}
    </>
  );
};

export default DeativateQList;
